/**
 * Created by jpilz on 2/13/17.
 */
import 'babel-polyfill';
import ko from 'knockout';
import Raven from 'raven-js';
import utils from './utils';
import bootUtil from './bootUtil';
import profileUtil from './profileUtil';
import ssoUtil from './ssoUtil';
import optionsUtil from './optionsUtil';

//import $ from 'jquery';
//import async from 'async';
//import reviewObj from './reviewObj';
//import axios from 'axios';
//import profileObj from './profileObj';
//import reviewUtil from './reviewUtil';
//import jdmApiUtil from './jdmApiUtil';
//import userObj from './userObj.js'; 


class contextModel{

    constructor() {
        this.name = "Job Description Manager";
        this.version = "0.9.54-CC";
        this.util = utils;
        this.id = ko.observable(this.util.guid());
        this.location = ko.observable("n/a");
        this.paramObj = ko.observable();
        this.preferences = ko.observable();
        this.debug = true;

        this.Raven = Raven;

        //this.profileObj = ko.observable(new profileObj());

        this.ApplicationId = 'C66105B2-26D6-4502-9BD1-268615BB71FF';
        //this.ProfileApplicationId = '198a42e5-1bd7-430b-8e44-13f5e73432f8';

        /*
          Modes: 
            Standard - Normal JDM internal
            StandAlone - Stand alone JDM
            Review - Reviewer Only
            POE - POE Admin
        */

        //Login Status Object
        this.loginStatusObj = ko.observable({
            staticParams: "",
            urlParams: "", 
            API:"", 
            JDMAPI:"", 
            Mode: null, 
            User: null, 
            UserValid:false, 
            Profile: false, 
            Preferences: false, 
            ApplicationData:false, 
            Complete: false
        }).extend({notify: 'always'});

        //URL Params
        this.bootLoopIndex = 0;

        this.user = ko.observable();

        //App Information
        this.hasBeenModified = ko.observable(false);

        this.sortColumn = ko.observable('title');

        //Job Array
        this.userJobsArray = ko.observableArray([]);
        this.customHeaderTitles = ko.observable({});

        //Custom Header Data 
        this.customHeaderColumn1Data = ko.observableArray([]);
        this.customHeaderColumn2Data = ko.observableArray([]);
        this.customHeaderColumn3Data = ko.observableArray([]);
        this.customHeaderColumn4Data = ko.observableArray([]);
        this.customHeaderColumn5Data = ko.observableArray([]);
        this.customHeaderColumn6Data = ko.observableArray([]);

        this.userEmployeeList = ko.observableArray([]);

        //User Information
        this.subid = ko.observable("");
        this.subparentid = ko.observable("");
        this.partnerid = ko.observable(1);
        this.hasParent = ko.observable(false);

        this.preferencesId = ko.observable(null);
        this.preferences = ko.observable({"columnViewList":{
            "optioncolumn1Visible":true,
            "optioncolumn2Visible":true,
            "optioncolumn3Visible":true,
            "optioncolumn4Visible":false,
            "optioncolumn5Visible":false,
            "optioncolumn6Visible":false}
            ,
            "featuresOff":[]});

        //User ID only used for sub users
        this.userid = ko.observable('0');
        this.user_email = ko.observable('');

        this.ONetUrl = "https://services.onetcenter.org/ws/online/";
        this.ONetUrlLic = "client=blr";
        this.styleSheet = ko.observable({ class1: 'Class 1', class2: 'Class 2',class3: 'Class 3', style4: 'Class 4'});
        this.inLineStyleArray = ko.observableArray([]);
        this.inLineStyleFormatted = ko.observable();

        console.log("document.location.hostname: %o", document.location.hostname)

        if(document.location.hostname == "dev.sites.com")
        {
            this.apiEntryPointUrl = "http://localhost:3000/api";
        }
        else if (document.location.hostname == "dev.sites.blr.com") 
        {
            this.apiEntryPointUrl = "http://staging.jdmapi.blr.com/api";
        }
        else if (document.location.hostname == "staging.cc-hero.blr.com") 
        {
            this.apiEntryPointUrl = "http://staging.jdmapi.blr.com/api";
        }
        else if (document.location.hostname == "staging.jdmapi.blr.com") 
        {
            this.apiEntryPointUrl = "http://staging.jdmapi.blr.com/api";
        }
        else if (document.location.hostname == "staging.jdm2.blr.com") 
        {
            this.apiEntryPointUrl = "http://staging.jdmapi.blr.com/api";
        }
        else
        {
            this.apiEntryPointUrl = "https://jdmapi.blr.com/api"; 
        }
        
        this.apiContentType = {'Content-type': 'application/json; charset=utf-8', 'crossDomain': true};
        this.apiAppId = "c66105b2-26d6-4502-9bd1-268615bb71ff";
        this.apiUserName = "JDM";
        this.apiUserID = 0;
        this.apiAccessToken = "";
        this.apiEntryPointPdf = "https://jdmapi.blr.com/pdf/done";

        //Profile 
        this.profileClientID = "LSVhYa5Sdoiifl9";
        this.profileSecret = "IPQebsCU0W4qiOB";
        this.profileToken = "";

        this.profileObject = ko.observable({});

        //Event Manager
        this.eventManager = new ko.subscribable();

        this.eventManager.subscribe((loginObj) =>{
            console.log("loginStatus");
            console.log(loginObj);
            //this.int(loginObj);
        },this, "loginStatus");


        //this.init();
        //this.processUrlParams();
        //this.checkCookiesAndAPILogin();

        this.initSentry();

        

    }

    init() {
        // This init is called form the header so it loads any params passed in.
        console.clear();
        console.log("document.location.hostname: %o", document.location.hostname);
        console.log("context:constructor  version: %o", this.version);
        let boot = new bootUtil(this);
        boot.processloginStatusObj();

    }

    initSentry() {
        this.Raven.config('https://74412283d2ad49eca54272738f632bf1@sentry.develup.com/6').install();
        this.Raven.captureMessage('Boot', {level:'info'});
    }

    processUrlParams() {

        console.log("Context: processUrlParams:");
        
        var oGetVars = {};
        if (window.location.search.length > 1) {
          for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&"); nKeyId < aCouples.length; nKeyId++) {
            aItKey = aCouples[nKeyId].split("=");
            oGetVars[decodeURIComponent(aItKey[0])] = aItKey.length > 1 ? decodeURIComponent(aItKey[1]) : "";
          }
        }

        this.loginStatusObj().urlParams = oGetVars;
        
        console.log(this.loginStatusObj());
        this.loginStatusObj.valueHasMutated();

    }

    intAfterUserLogin() {

    }

    checkCookiesAndAPILogin() {

        // Is Authenticated 
        console.log("Context:checkCookiesAndAPILogin:SSO isAuthenticated:");
        let ssoUtilObj = new ssoUtil(this);

        ssoUtilObj.isAuthenticated().then( response => { 
            if(response == "false")
            {
                ssoUtilObj.login({username:"blrnpd",password:"smiley"});
            }
        });

        //Get Profile Login Token
        console.log("Context:checkCookiesAndAPILogin:Profile Login Token");

        let profileUtilObj = new profileUtil(this);
        profileUtilObj.getToken().then( response => {

                console.log("Profile Response:");
                console.log(response);
                //console.lod(this.paramObj());

        });
        
        console.log("Context:checkCookiesAndAPILogin");
        console.log(this.readCookie('access_token'));
        console.log(this.readCookie('access_id'));

        if((this.readCookie('access_token') !== null) && (this.readCookie('access_id') !== null))
        {
            this.apiAccessToken = this.readCookie('access_token');
            this.apiUserID = this.readCookie('access_id');
            //context.userID(context.readCookie('100'));

            console.log("Context:checkCookiesAndAPILogin: Trying API AutoLogin");
            if(utils.tryAPIAutoLogin(this))
            {
                console.log("Context:checkCookiesAndAPILogin: API logged in");
                return;
            }
            else
            {
                utils.apiLogin(this);
                return;
            }
        }
        else
        {
            console.log("Trying API Login");
            utils.apiLogin(this);
            return;
        }

    }

    getInlineStyles() {

        console.log("getInlineStyles");
        let oUtil = new optionsUtil(this);
        //let self = this;

        oUtil.getInlineStyles("inline").then(function (result) {
            this.log("getInlineStyles: Return");
            //this.log(result);
            this.inLineStyleArray(result);
            this.formatInlineStyles();
        });

    }

    formatInlineStyles() {

        // 'Big Red': 'font-size: 20px; color: red;',
        let retnString = '{';
        let jsonStr = "";

        ko.utils.arrayForEach(this.inLineStyleArray(), function(item) {
            retnString += '"' + item.styleName() + '" : "' + item.inLineStyle() + '" ,';
        });

        //Remove Last ","
        retnString = retnString.substring(0, retnString.length-1);

        retnString += ' }';

        try {
            jsonStr = JSON.parse(retnString);
            this.inLineStyleFormatted(jsonStr);
        }
        catch(err)
        {
            console.log("context:formatInlineStyles:error:  error: %o", err);
            this.context.eventManager.notifySubscribers({modalTitle:"Inline Styles Parse Error:",modalBody:err},"messageModel");
        }
        
    }

    generateApiUrl(path) {

        let returnURL = "";

        if(path.indexOf('?') !== -1)
        {
            returnURL = this.apiEntryPointUrl + path + '&access_token=' + this.apiAccessToken;
        }
        else
        {
            returnURL = this.apiEntryPointUrl + path + '?access_token=' + this.apiAccessToken;
        }

        //return returnURL;
        console.log("context:generateApiUrl Complete returnURL: %o", returnURL);

        return returnURL;
        
    }

    //Cookie Functions
    createCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }

        document.cookie = name + "=" + value + expires + "; path=/";
    }
    
    readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    
    eraseCookie(name) {
        this.createCookie(name,"",-1);
    }
}

export let  context = new contextModel();

/*

{"Green" : "color: green; font-style: italic;" ,"Italic" : "font-style: italic;color: blue;" ,"ItemList" : "list-style-type:circle" ,"Red Underlined" : "color: blue; text-decoration: underline;" ,"Test" : "color: green;font-size: 24px;" ,"Title" : "font-size: 28px; font-family: Arial, Helvetica, sans-serif; font-weight: bold;"  }


*/


// WEBPACK FOOTER //
// ./src/objects/context.js